import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CTASection from '../components/sections/CTASection';
import SocialProof from '../components/sections/SocialProof';

const learnItems = [
  'jak připravit hodinu rychleji a efektivněji',
  'jak z jedné přípravy vytvořit varianty pro různé úrovně žáků',
  'jak vytvořit pracovní list, test nebo opakovací materiál',
  'jak upravit text podle věku a úrovně žáků',
  'jak připravit zadání, které AI nevyřeší místo žáka',
  'jak využít AI při slovním hodnocení',
  'jak si pomoci s administrativou',
  'jak komunikovat s rodiči pomocí AI',
  'jak řešit AI ve škole se žáky',
];

export default function ObsahACenaPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>

        {/* Hero */}
        <section className="pt-36 pb-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="inline-flex items-center px-4 py-2 bg-teal-50 border border-teal-100 rounded-full text-teal-700 text-sm font-medium mb-8">
              Kurz je možné financovat z OP JAK II
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-slate-900 leading-tight">
              Obsah a cena školení
            </h1>
          </div>
        </section>

        {/* Obsah */}
        <section className="py-16 bg-slate-50 border-t border-slate-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-sm font-semibold text-slate-400 tracking-widest uppercase mb-6">Obsah školení</p>
            <p className="text-xl text-slate-700 font-medium mb-8 max-w-2xl">
              Během školení se pedagogové naučí například:
            </p>
            <div className="grid sm:grid-cols-2 gap-3 max-w-3xl">
              {learnItems.map((item, i) => (
                <div key={i} className="flex items-start gap-3 bg-white rounded-lg px-4 py-3 border border-slate-200">
                  <div className="w-2 h-2 rounded-full bg-teal-500 flex-shrink-0 mt-2" />
                  <span className="text-slate-700 text-sm leading-relaxed">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Organizace a cena */}
        <section className="py-16 bg-white border-t border-slate-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-sm font-semibold text-slate-400 tracking-widest uppercase mb-8">Organizace a cena</p>
            <div className="grid md:grid-cols-2 gap-8 max-w-3xl">

              {/* Info */}
              <div className="space-y-5">
                {[
                  { label: 'Délka školení', value: '8 vyučovacích hodin' },
                  { label: 'Forma', value: 'Online kurz nebo prezenční školení ve škole' },
                  { label: 'Prezenční forma', value: 'od 8 účastníků' },
                  { label: 'Certifikát', value: 'Každý účastník obdrží certifikát' },
                ].map((row, i) => (
                  <div key={i} className="border-b border-slate-100 pb-4">
                    <p className="text-xs font-semibold text-slate-400 tracking-widest uppercase mb-1">{row.label}</p>
                    <p className="text-base text-slate-800 font-medium">{row.value}</p>
                  </div>
                ))}
              </div>

              {/* Price box */}
              <div className="bg-gradient-to-br from-teal-600 to-cyan-600 rounded-2xl p-8 text-white flex flex-col justify-center">
                <p className="text-teal-100 text-sm font-semibold tracking-widest uppercase mb-4">Cena školení</p>
                <p className="text-5xl font-black tracking-tight mb-1">3 400 Kč</p>
                <p className="text-teal-100 text-base mb-6">za účastníka</p>
                <div className="border-t border-teal-500 pt-5">
                  <p className="text-teal-100 text-sm">Kurz lze financovat z</p>
                  <p className="text-white font-bold text-lg">OP JAK II</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SocialProof />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
